"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAGE_PRODUCTION = exports.STAGE_DEVELOPMENT = exports.STAGE_BETA = exports.ENV_STAGE = void 0;
const ENV_STAGE = exports.ENV_STAGE = 'WASABI_STAGE';
const STAGE_BETA = exports.STAGE_BETA = 'beta';
const STAGE_PRODUCTION = exports.STAGE_PRODUCTION = 'production';
const STAGE_DEVELOPMENT = exports.STAGE_DEVELOPMENT = 'development';